'use client'

import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'

import { schedulePathAwareNonCriticalWork } from '@/lib/perf/scheduleNonCriticalWork'

const ToastifyContainer = dynamic(
  () => import('react-toastify').then(mod => mod.ToastContainer),
  { ssr: false }
)

const LazyToastifyProvider = () => {
  const pathname = usePathname()
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    return schedulePathAwareNonCriticalWork(pathname, () => {
      setShouldLoad(true)
    })
  }, [pathname])

  useEffect(() => {
    if (!shouldLoad) {
      return
    }

    void import('react-toastify/dist/ReactToastify.css')
  }, [shouldLoad])

  if (!shouldLoad) {
    return null
  }

  return (
    <ToastifyContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
    />
  )
}

export default LazyToastifyProvider
